"use client";

import { useEffect } from "react";

import { armRevealOnScroll } from "./reveal-on-scroll";

/** Arms the homepage scroll reveals once, after hydration. Renders nothing. */
export const RevealOnScroll = () => {
  useEffect(() => armRevealOnScroll(), []);
  return null;
};
